import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appLayoutContentId } from "@amzn/meridian/app-layout";

export function ScrollToTop({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const appContent = document.getElementById(appLayoutContentId);
    appContent.scrollTop = 0;
  }, [pathname]);

  return <React.Fragment>{children}</React.Fragment>;
}
